import React, { useState, useEffect } from "react";
import "../../assets/styles/dashboard.css";
import AdminSidebar from "../../components/layout/AdminSidebar";

function AdminDashboard() {

  const [totalStudents, setTotalStudents] = useState(0);
  const [presentToday, setPresentToday] = useState(0);
  const [pendingPayments, setPendingPayments] = useState(0);
  const [open, setOpen] = useState(false);  // 👈 MUST be false

  useEffect(() => {
    fetch("https://shuttle-craft-student-transport.onrender.com/api/students/dashboard/stats")
      .then(res => res.json())
      .then(data => {
        setTotalStudents(data.totalStudents);
        setPresentToday(data.presentToday);
        setPendingPayments(data.pendingPayments);
      })
      .catch(error => {
        console.error("Error loading dashboard stats:", error);
      });
  }, []);

  return (
    <>
      {/* ✅ SIDEBAR */}
      <AdminSidebar open={open} setOpen={setOpen} />
  
      {/* ✅ MAIN CONTENT */}
      <div className="main-content">
  
        {/* ✅ NAVBAR WITH MENU BUTTON */}
        <div className="admin-navbar">
          Admin Dashboard
        </div>
  
        {/* ✅ CARDS */}
        <div className="cards">
  
          <div className="card">
            <h3>Total Students</h3>
            <p>{totalStudents}</p>
          </div>
  
          <div className="card">
            <h3>Present Today</h3>
            <p>{presentToday}</p>
          </div>
  
          <div className="card">
            <h3>Pending Payments</h3>
            <p>{pendingPayments}</p>
          </div>
  
        </div>
  
      </div>
    </>
  );
}

export default AdminDashboard;